// extracted by mini-css-extract-plugin
module.exports = {"title":"default_title__oS5AX","text":"default_text__A_cAC","button":"default_button__dDcJm","loginText":"default_loginText__957N3","loginLink":"default_loginLink__ST3Nn"};